import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { ActivityLeaderboardModule, DateRangeSelectorComponent, DateRange } from '@galaxy/crm/static';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [
    CommonModule,
    TranslateModule,
    ActivityLeaderboardModule,
    GalaxyPageModule,
    MatButton,
    DateRangeSelectorComponent,
  ],
  templateUrl: './leaderboard-page.component.html',
})
export class LeaderboardPageComponent {
  private selection$$ = new BehaviorSubject<DateRange | null>(null);
  selection$ = this.selection$$.asObservable();

  onDateChange(value: DateRange): void {
    this.selection$$.next({
      dateRangeStart: value.dateRangeStart,
      dateRangeEnd: value.dateRangeEnd,
    });
  }
}
